export const positions = Object.freeze([
  'top-[22.5%] left-[calc(50%+20px)] md:left-[calc(50%+45px)] md:top-[32.5%] lg:top-[30%] max-w-400 xl:max-w-500',
  'top-[47.5%] right-[calc(50%+110px)] md:top-[55%] lg:top-[50%] md:right-[calc(50%+195px)] lg:right-[calc(50%+165px)] xl:right-[calc(50%+195px)] max-w-335 xl:max-w-400',
  'top-[60%] left-[calc(50%+35px)] md:left-[calc(50%+65px)] md:top-[67%] lg:top-[62.5%] max-w-400 xl:max-w-500',
  'top-[80%] right-[calc(50%+15px)] md:top-[85%] lg:top-[80%] md:right-[calc(50%+35px)] max-w-400 xl:max-w-500',
  'top-[85%] left-[calc(50%+35px)] md:top-[90%] lg:top-[85%] md:left-[calc(50%+55px)] max-w-400 xl:max-w-500',
]);

export const sides = Object.freeze(['Right', 'Left', 'Right', 'Left', 'Right']);
